import { useEffect } from 'react';

/**
 * Custom hook to handle ESC key press for modals
 * @param {boolean} isOpen - Whether the modal/component is open
 * @param {function} onEscape - Function to call when ESC is pressed
 * @param {array} deps - Additional dependencies for the effect (optional)
 */
const useEscapeKey = (isOpen, onEscape, deps = []) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onEscape();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, onEscape, ...deps]);
};

export default useEscapeKey;